import brand, { themes } from '@helpers/brand';
import { cssVar } from '@helpers/cssVar';
import { Layers } from '@helpers/layers';
import { Device, from, until } from '@helpers/media';
import SiteWide from '@stories/Components/Global/SiteWide/SiteWide';
import { rgba } from 'polished';
import styled, { css } from 'styled-components';
const Container = styled.header `
  ${({ themeOption }) => themeOption && themes[themeOption]}

  position: absolute;
  top: 0;
  left: 0;
  display: grid;
  background: none;
  color: ${cssVar('fgColor')};
  height: 150px;
  transition: background-color 0.3s ease-out, box-shadow 0.3s ease-out, color 0.3s ease-out,
    height 0.3s ease-out, transform 0.3s ease-out;
  width: 100%;
  z-index: ${Layers.Header};

  .hamburger-react {
    display: none;
    margin-left: auto;
  }

  ${({ background }) => background &&
    css `
      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        background: linear-gradient(to bottom, ${rgba(brand.black, 1)}, ${rgba(brand.black, 0)});
        max-height: 385px;
        height: 30vh;
        pointer-events: none;
        width: 100%;
      }
    `}

  @media ${until(Device.Tablet)} {
    height: 78px;

    .hamburger-react {
      display: block;
    }

    ${({ background }) => background &&
    css `
        &::before {
          height: 170px;
        }
      `}
  }
`;
const Inner = styled(SiteWide) `
  position: relative;
  display: flex;
  align-items: center;
`;
const LogoLink = styled.a `
  display: block;
  color: currentColor;

  &:focus {
    outline: auto;
    outline-offset: 5px;
  }
`;
const Logo = styled.span `
  display: block;
  height: 55px;
  margin-right: 16px;
  width: 85px;

  @media ${from(Device.TabletLarge)} {
    height: 75px;
    width: 116px;
  }

  @media ${from(Device.Desktop)} {
    height: 105px;
    width: 161px;
  }
`;
const CtaWrapper = styled.div `
  margin-left: 24px;

  @media ${until(Device.Tablet)} {
    display: none;
  }

  @media ${from(Device.Desktop)} {
    margin-left: 82px;
  }
`;
export default {
    Container,
    CtaWrapper,
    Inner,
    Logo,
    LogoLink,
};
